import { createContext } from 'react';
import type { StorageMode } from './driver';
import type { LocalDb } from './localDb';
import type { MeResponse } from './me';
import type { SyncClient } from './syncClient';

export interface DataContextValue {
  db: LocalDb;
  userId: string;
  tz: string;
  mode: StorageMode;
  persisted: boolean | null;
  sync: SyncClient;
  me: MeResponse | null;
  refreshMe(): Promise<void>;
  /** Sign-out: stops sync, closes the device database, and deletes its file. */
  wipeLocalData(): Promise<void>;
}

export const DataContext = createContext<DataContextValue | null>(null);
